import React, { useEffect, useMemo, useRef } from 'react';
import Routes from './Routes';
import ResetCartDlg from './containers/reset-cart-dlg/ResetCartDlg';
import MsgSnackbar from './components/msg-snackbar/MsgSnackbar';
import { useSelector, useDispatch } from 'react-redux';
import useFirebase from './hooks/firebase';
import md5 from 'blueimp-md5';
import config from './config';
import AppFeedback from './containers/app-feedback/AppFeedback';
import AppTips from './containers/app-tips/AppTips';
import SignupDlg from './containers/signup-dlg/SignupDlg';
import { fetchSessionId } from './actions/auth';
import useApp from './hooks/app';
import Loading from './components/loading/Loading';

const Container = () => {
	const { selectedPod, affiliateActive, affiliateData } = useSelector((state) => state.pod || {});
	const { mobile } = useSelector((state) => state.user || {});
	const { sessionId } = useSelector((state) => state.auth || {});
	const [{ syncing }, startSync] = useApp();
	const dispatch = useDispatch();
	const [, setUserProperties, setUserId] = useFirebase();
	useEffect(() => {
		setUserProperties({ version: config.RELEASE_VER });
		if (affiliateActive) {
			const { page_id = 'affiliate' } = affiliateData;
			setUserProperties({ location: page_id });
		} else if (selectedPod) {
			setUserProperties({ location: selectedPod.location });
		}

		if (mobile) {
			setUserId(md5(mobile));
		} else {
			setUserId('guest');
		}

		if (window.matchMedia('(display-mode: standalone)').matches) {
			setUserProperties({ tm_launch: 'installed_app' });
		} else {
			setUserProperties({ tm_launch: 'web' });
		}

		dispatch(fetchSessionId(sessionId));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const startSyncing = useRef(false);
	useMemo(() => {
		if (selectedPod && (!selectedPod.latlong || (selectedPod.ds_imei && !selectedPod.ds_geocode))) {
			startSyncing.current = true;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (startSyncing.current) {
			startSyncing.current = false;
			startSync();
		}
	}, [startSync]);

	// const firebase = useContext(FirebaseContext);
	// console.log('Container -> firebase', firebase)

	return (
		<>
			{startSyncing.current || syncing ? (
				<section style={{ minHeight: 'inherit' }}>
					<Loading message='Syncing application' style={{ color: 'white' }} />
				</section>
			) : (
				<>
					<Routes />
					<ResetCartDlg />
					<MsgSnackbar />
					<AppFeedback />
					<AppTips />
					<SignupDlg />
				</>
			)}
			{/* <AppUpdate /> */}
		</>
	);
};

export default Container;
